import React from 'react';
import { CircularProgress, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(({
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.3)',
        zIndex: 99,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

function Loading({ show }) {
    const classes = useStyles();

    if (!show) return null;
    return (
        <Box className={classes.container}>
            <CircularProgress color="inherit" />
        </Box>
    );
}

Loading.propTypes = {
    show: PropTypes.bool
};

export default Loading;
